// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.create_product_container {
  background-color: var(--ColorThird);
  position: relative;
  z-index: 2;
  padding: 3rem;
  border-radius: 20px;
  font-family: "Nun", sans-serif;
}
.close_product_container {
  margin-left: 90%;
}
.close_product_container button {
  border: none;
  background-color: var(--ColorSecondaryDark);
  color: white;
  font-weight: bolder;
  border-radius: 100%;
  height: 36px;
  width: 30px;
  transition: 0.5s ease-in-out;
}
.close_product_container button:hover {
  box-shadow: 0px 0px 26px -5px rgba(0, 0, 0, 0.75);
}
.create_product_form {
  display: flex;
  flex-direction: column;
}
.create_product_form input {
  border: 1px solid var(--ColorSecondaryDark);
  border-radius: 20px;
  margin: 0.5rem;
  padding: 0.5rem;
  padding-left: 1rem;
}
.create_product_form #picture {
  border: none;
  border-radius: 0px;
}
.create_product_form_picture_box {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.create_product_form_name_description_box {
  display: flex;
  flex-direction: column;
}
.create_product_form_name_description_box textarea {
  border: 1px solid var(--ColorSecondaryDark);
  border-radius: 20px;
  margin: 0.5rem;
  padding: 0.5rem;
}
.create_product_form_price_box {
  display: flex;
  flex-direction: column;
}
.create_product_form_price_box input {
  width: 15%;
}
.create_product_form_submit_box {
  display: flex;
  justify-content: center;
}
.create_product_form_submit_box input {
  width: 30%;
  padding: 10px;
  margin: 1rem;
  background-color: var(--ColorSecondaryDark);
  color: white;
  transition: 0.5s ease-in-out;
}
.create_product_form_submit_box input:hover {
  box-shadow: 0px 0px 20px -5px rgba(0, 0, 0, 0.75);
}
.create_product_form_complements {
  border: 1px solid black;
  border-radius: 20px;
  padding: 20px;
  height: 15vmax;
  overflow: auto;
}
.create_product_form_complements_box {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  
}
.create_product_form_dropdown_box {
  display: flex;
  flex-direction: row;
  height: 10%;
}
.create_product_form_dropdown_box select {
  border-radius: 20px;
  border: 1px solid var(--ColorSecondaryDark);
}
.create_product_form_inserted_complements {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin: 1rem;

}
.hidden-input {
  opacity: 0; /* Hide the actual input */
  display: none;
}
.inserted_complement_picture {
  margin: 0;
  width: 35%;
  height: 50%;
}
.inserted_complement_picture img {
  width: 100%;
  height: 100%;
  border-radius: 20%;
  object-fit: contain;
}
.placeholder-overlay {
  pointer-events: none;
  color: rgb(0, 0, 0);
}
.button_products {
  border-radius: 100%;
  border: none;
  width: 45px;
  padding: 10px;
  margin: 1rem;
  background-color: var(--ColorSecondaryDark);
  color: white;
  transition: 0.5s ease-in-out;
}
.button_products:hover {
  box-shadow: 0px 0px 20px -5px rgba(0, 0, 0, 0.75);
}
.button_products_delete_complements {
  border-radius: 100%;
  border: none;
  width: 8%;
  height: 5%;
  padding: 1rem;
  margin: 1rem;
  background-color: var(--ColorSecondaryDark);
  color: white;
  transition: 0.5s ease-in-out;
}
.button_products_delete_complements:hover {
  box-shadow: 0px 0px 20px -5px rgba(0, 0, 0, 0.75);
}
.create_product_form_reset {
  background-color: var(--ColorPrimary);
  font-weight: 700;
  color: var(--ColorSecondaryDark);
  transition: 0.5s;
  width: 30%;
  padding: 10px;
  margin: 1rem;
  border: none;
  border-radius: 20px;
  transition: 0.5s ease-in-out;
}
.create_product_form_reset:hover {
  box-shadow: 0px 0px 20px -5px rgba(0, 0, 0, 0.75);
}
`, "",{"version":3,"sources":["webpack://./src/components/createProductComponent/createProductComponent.css"],"names":[],"mappings":"AAAA;EACE,mCAAmC;EACnC,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,2CAA2C;EAC3C,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,4BAA4B;AAC9B;AACA;EACE,iDAAiD;AACnD;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,2CAA2C;EAC3C,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,2CAA2C;EAC3C,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,UAAU;AACZ;AACA;EACE,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,UAAU;EACV,aAAa;EACb,YAAY;EACZ,2CAA2C;EAC3C,YAAY;EACZ,4BAA4B;AAC9B;AACA;EACE,iDAAiD;AACnD;AACA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;;AAEhC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,2CAA2C;AAC7C;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;;AAEd;AACA;EACE,UAAU,EAAE,0BAA0B;EACtC,aAAa;AACf;AACA;EACE,SAAS;EACT,UAAU;EACV,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,YAAY;EACZ,2CAA2C;EAC3C,YAAY;EACZ,4BAA4B;AAC9B;AACA;EACE,iDAAiD;AACnD;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,SAAS;EACT,UAAU;EACV,aAAa;EACb,YAAY;EACZ,2CAA2C;EAC3C,YAAY;EACZ,4BAA4B;AAC9B;AACA;EACE,iDAAiD;AACnD;AACA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,4BAA4B;AAC9B;AACA;EACE,iDAAiD;AACnD","sourcesContent":[".create_product_container {\n  background-color: var(--ColorThird);\n  position: relative;\n  z-index: 2;\n  padding: 3rem;\n  border-radius: 20px;\n  font-family: \"Nun\", sans-serif;\n}\n.close_product_container {\n  margin-left: 90%;\n}\n.close_product_container button {\n  border: none;\n  background-color: var(--ColorSecondaryDark);\n  color: white;\n  font-weight: bolder;\n  border-radius: 100%;\n  height: 36px;\n  width: 30px;\n  transition: 0.5s ease-in-out;\n}\n.close_product_container button:hover {\n  box-shadow: 0px 0px 26px -5px rgba(0, 0, 0, 0.75);\n}\n.create_product_form {\n  display: flex;\n  flex-direction: column;\n}\n.create_product_form input {\n  border: 1px solid var(--ColorSecondaryDark);\n  border-radius: 20px;\n  margin: 0.5rem;\n  padding: 0.5rem;\n  padding-left: 1rem;\n}\n.create_product_form #picture {\n  border: none;\n  border-radius: 0px;\n}\n.create_product_form_picture_box {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n}\n.create_product_form_name_description_box {\n  display: flex;\n  flex-direction: column;\n}\n.create_product_form_name_description_box textarea {\n  border: 1px solid var(--ColorSecondaryDark);\n  border-radius: 20px;\n  margin: 0.5rem;\n  padding: 0.5rem;\n}\n.create_product_form_price_box {\n  display: flex;\n  flex-direction: column;\n}\n.create_product_form_price_box input {\n  width: 15%;\n}\n.create_product_form_submit_box {\n  display: flex;\n  justify-content: center;\n}\n.create_product_form_submit_box input {\n  width: 30%;\n  padding: 10px;\n  margin: 1rem;\n  background-color: var(--ColorSecondaryDark);\n  color: white;\n  transition: 0.5s ease-in-out;\n}\n.create_product_form_submit_box input:hover {\n  box-shadow: 0px 0px 20px -5px rgba(0, 0, 0, 0.75);\n}\n.create_product_form_complements {\n  border: 1px solid black;\n  border-radius: 20px;\n  padding: 20px;\n  height: 15vmax;\n  overflow: auto;\n}\n.create_product_form_complements_box {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  \n}\n.create_product_form_dropdown_box {\n  display: flex;\n  flex-direction: row;\n  height: 10%;\n}\n.create_product_form_dropdown_box select {\n  border-radius: 20px;\n  border: 1px solid var(--ColorSecondaryDark);\n}\n.create_product_form_inserted_complements {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  margin: 1rem;\n\n}\n.hidden-input {\n  opacity: 0; /* Hide the actual input */\n  display: none;\n}\n.inserted_complement_picture {\n  margin: 0;\n  width: 35%;\n  height: 50%;\n}\n.inserted_complement_picture img {\n  width: 100%;\n  height: 100%;\n  border-radius: 20%;\n  object-fit: contain;\n}\n.placeholder-overlay {\n  pointer-events: none;\n  color: rgb(0, 0, 0);\n}\n.button_products {\n  border-radius: 100%;\n  border: none;\n  width: 45px;\n  padding: 10px;\n  margin: 1rem;\n  background-color: var(--ColorSecondaryDark);\n  color: white;\n  transition: 0.5s ease-in-out;\n}\n.button_products:hover {\n  box-shadow: 0px 0px 20px -5px rgba(0, 0, 0, 0.75);\n}\n.button_products_delete_complements {\n  border-radius: 100%;\n  border: none;\n  width: 8%;\n  height: 5%;\n  padding: 1rem;\n  margin: 1rem;\n  background-color: var(--ColorSecondaryDark);\n  color: white;\n  transition: 0.5s ease-in-out;\n}\n.button_products_delete_complements:hover {\n  box-shadow: 0px 0px 20px -5px rgba(0, 0, 0, 0.75);\n}\n.create_product_form_reset {\n  background-color: var(--ColorPrimary);\n  font-weight: 700;\n  color: var(--ColorSecondaryDark);\n  transition: 0.5s;\n  width: 30%;\n  padding: 10px;\n  margin: 1rem;\n  border: none;\n  border-radius: 20px;\n  transition: 0.5s ease-in-out;\n}\n.create_product_form_reset:hover {\n  box-shadow: 0px 0px 20px -5px rgba(0, 0, 0, 0.75);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
